export const SPACEBAR_KEYCODE = 32;
export const SPACEBAR_KEY = ' ';
